module.exports = __webpack_public_path__ + "media/images/xpass/brand_previews/purebarre-b1650598fb4997d36db5b177b184e677.jpg";